import { Container } from "@mui/material";
import Page from "../components/Page";
import { UserRoleManagement } from "../features/user-role";

export default function UserRoles() {
    return (
        <Page title="User roles | HCC">
            <Container maxWidth="xl">
                <UserRoleManagement />
            </Container>
        </Page>
    );
}
